<template>
  <div class="margin-at-mobile changeOption d-flex align-content-center justify-content-end gap-4 mb-3 p-4">
    <div class="d-flex align-content-center gap-2 pointer">
      <label for="garden">باغ دارم</label>
      <input
          type="radio"
          id="garden"
          v-model="selectedOption"
          value="garden"
          @change="handleChange"
      >
    </div>
    <div class="d-flex align-content-center gap-2">
      <label for="farm">زمین زراعی دارم</label>
      <input
          type="radio"
          id="farm"
          v-model="selectedOption"
          value="farm"
          @change="handleChange"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeServiceSelection',
  data() {
    return {
      selectedOption: '',
    }
  },
  mounted() {
    let path = this.$route.fullPath;
    let sections = path.split("/");
    let lastSection = sections[sections.length - 1];
    if (lastSection !== "edit") {
      if (path.includes('/farm/add')) {
        this.selectedOption = 'farm';
      } else if (path.includes('/garden/add')) {
        this.selectedOption = 'garden';
      }
    }
  },
  methods: {
    handleChange() {
      if (this.selectedOption === 'farm' && !this.$route.path.includes('/farm/add')) {
        this.$router.push('/farm/add');
      } else if (this.selectedOption === 'garden' && !this.$route.path.includes('/garden/add')) {
        this.$router.push('/garden/add');
      }
    }
  }
}
</script>

<style lang="scss">
.changeOption {
  border-radius: 20px;
  background-color: #fff;

  label {
    font-size: 14px;
  }

  input[type="radio"] {
    width: 18px;
    height: 18px;
  }
}
</style>
